import { useEffect } from "react";
import { useToast, UseToastOptions } from "@chakra-ui/react";
import { useAppSelector } from "~/store/hooks";
import { Toast } from "./Toast";

const id = "version-changed";
const toastOptions: UseToastOptions = {
  id,
  duration: null,
  isClosable: false,
  position: "top-left",
  render: () => <Toast />,
};

export function useVersionChanged(): void {
  const hasChanged = useAppSelector((state) => state.gitSha.hasChanged);
  const toast = useToast(toastOptions);

  useEffect(() => {
    if (!hasChanged) return;
    if (toast.isActive(id)) return;

    toast();
  }, [hasChanged, toast]);
}
